import React from 'react';
import {createNativeStackNavigator} from '@react-navigation/native-stack';
import SettingsScreen from '../screens/settings/SettingsScreen';
import ProfileScreen from '../screens/settings/ProfileScreen';
import RoleManagementScreen from '../screens/settings/RoleManagementScreen';
import LanguageScreen from '../screens/settings/LanguageScreen';
import CatalogItemListScreen from '../screens/measurement/CatalogItemListScreen';
import MeasurementTypeListScreen from '../screens/measurement/MeasurementTypeListScreen';
import OptionTypeListScreen from '../screens/optiontype/OptionTypeListScreen';
import OptionTypeDetailScreen from '../screens/optiontype/OptionTypeDetailScreen';
import CatalogItemMeasurementsScreen from '../screens/measurement/CatalogItemMeasurementsScreen';
import CatalogItemOptionTypesScreen from '../screens/measurement/CatalogItemOptionTypesScreen';
import TaskTypeListScreen from '../screens/task/TaskTypeListScreen';
import AddOnListScreen from '../screens/settings/AddOnListScreen';
import ServiceListScreen from '../screens/settings/ServiceListScreen';
import ExpenseCategoryListScreen from '../screens/settings/ExpenseCategoryListScreen';
import MaterialUnitListScreen from '../screens/settings/MaterialUnitListScreen';
import MaterialTypeListScreen from '../screens/settings/MaterialTypeListScreen';
import ReadymadeTypeListScreen from '../screens/settings/ReadymadeTypeListScreen';
import ReadymadeSizeListScreen from '../screens/settings/ReadymadeSizeListScreen';
import CouponListScreen from '../screens/settings/CouponListScreen';
import CouponFormScreen from '../screens/settings/CouponFormScreen';
import BillSettingsScreen from '../screens/settings/BillSettingsScreen';
import OrderSettingsScreen from '../screens/settings/OrderSettingsScreen';
import PaymentSettingsScreen from '../screens/settings/PaymentSettingsScreen';
import TaxSettingsScreen from '../screens/settings/TaxSettingsScreen';
import WorkingHoursScreen from '../screens/settings/WorkingHoursScreen';
import PriceBookListScreen from '../screens/settings/PriceBookListScreen';
import PriceBookPricesScreen from '../screens/settings/PriceBookPricesScreen';
import WorkerTypeListScreen from '../screens/workertype/WorkerTypeListScreen';
import UserListScreen from '../screens/user/UserListScreen';
import UserFormScreen from '../screens/user/UserFormScreen';
import UserDetailScreen from '../screens/user/UserDetailScreen';

const Stack = createNativeStackNavigator();

const SettingsNavigator = () => {
  return (
    <Stack.Navigator screenOptions={{headerShown: false}}>
      <Stack.Screen name="SettingsMain" component={SettingsScreen} />
      <Stack.Screen name="Profile" component={ProfileScreen} />
      <Stack.Screen name="RoleManagement" component={RoleManagementScreen} />
      <Stack.Screen name="CatalogItems" component={CatalogItemListScreen} />
      <Stack.Screen name="CatalogItemMeasurements" component={CatalogItemMeasurementsScreen} />
      <Stack.Screen name="CatalogItemOptionTypes" component={CatalogItemOptionTypesScreen} />
      <Stack.Screen name="MeasurementTypes" component={MeasurementTypeListScreen} />
      <Stack.Screen name="OptionTypes" component={OptionTypeListScreen} />
      <Stack.Screen name="OptionTypeDetail" component={OptionTypeDetailScreen} />
      <Stack.Screen name="TaskTypes" component={TaskTypeListScreen} />
      <Stack.Screen name="Services" component={ServiceListScreen} />
      <Stack.Screen name="AddOns" component={AddOnListScreen} />
      <Stack.Screen name="ExpenseCategories" component={ExpenseCategoryListScreen} />
      <Stack.Screen name="MaterialUnits" component={MaterialUnitListScreen} />
      <Stack.Screen name="MaterialTypes" component={MaterialTypeListScreen} />
      <Stack.Screen name="ReadymadeTypes" component={ReadymadeTypeListScreen} />
      <Stack.Screen name="ReadymadeSizes" component={ReadymadeSizeListScreen} />
      <Stack.Screen name="Coupons" component={CouponListScreen} />
      <Stack.Screen name="CouponForm" component={CouponFormScreen} />
      <Stack.Screen name="BillSettings" component={BillSettingsScreen} />
      <Stack.Screen name="OrderSettings" component={OrderSettingsScreen} />
      <Stack.Screen name="PaymentSettings" component={PaymentSettingsScreen} />
      <Stack.Screen name="TaxSettings" component={TaxSettingsScreen} />
      <Stack.Screen name="WorkingHours" component={WorkingHoursScreen} />
      <Stack.Screen name="Language" component={LanguageScreen} />
      <Stack.Screen name="PriceBooks" component={PriceBookListScreen} />
      <Stack.Screen name="PriceBookPrices" component={PriceBookPricesScreen} />
      <Stack.Screen name="WorkerTypes" component={WorkerTypeListScreen} />
      <Stack.Screen name="UserList" component={UserListScreen} />
      <Stack.Screen name="UserForm" component={UserFormScreen} />
      <Stack.Screen name="UserDetail" component={UserDetailScreen} />
    </Stack.Navigator>
  );
};

export default SettingsNavigator;
